interface Headers {
  readonly [key: string]: string
}

interface CurlCommandProps {
  /** A string describing only the protocol (http / https) and host (contrastsecurity.com) */
  readonly protocolAndHost: string
  readonly path: string
  readonly method?: 'GET' | 'POST' | 'HEAD'
  readonly headers?: Headers
  readonly body?: {
    readonly [key: string]: any
  }
}

function buildCurlHeaders(headers: Headers) {
  return Object.keys(headers).reduce<string>((prev, key, index) => {
    return `${prev}  -H '${key}: ${headers[key]}' ${
      index + 1 === Object.keys(headers).length ? '' : '\\\n'
    }`
  }, '')
}

/** Returns a formatted cURL command */
export function buildCurlCommand({
  protocolAndHost,
  path,
  method = 'GET',
  headers,
  body
}: CurlCommandProps): string {
  let command = `curl -X ${method} \\
  "${protocolAndHost}${path}" ${headers ? '\\\n' : ''}`

  if (headers) {
    command += buildCurlHeaders(headers)
  }

  if (body) {
    command += `${`\\\n  -d '${JSON.stringify(body)}'`}`
  }

  return command
}
